export default __webpack_public_path__ + "static/media/sideproject_bg.1871feeb.jpg";